export default __webpack_public_path__ + "static/Wizard_07-e8958b1c5dbd726feb13bf09d9114c52.webp";